'use client';

export { default } from './Fab';
export { default as fabClasses } from './fabClasses';
export * from './fabClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Fab/index.js
// module id = 279
// module chunks = 22